import { uniq } from 'lodash';

import { RouteSequenceApiV4Interface } from '@/types/api-types';

export const getApiOptionCarrierIds = (option: RouteSequenceApiV4Interface): string[] => {
  const allCarriers = option.segments.reduce((acc, segment) => {
    if ('carrierIds' in segment && segment.carrierIds) {
      return [...acc, ...segment.carrierIds];
    }
    return acc;
  }, [] as string[]);
  return uniq(allCarriers);
};
